module.exports = function getResource(label, vars = []) {
    let resources = {
        valueLabel: 'VALEUR',
        valueLabelLower: 'valeur'
    };

    return resources[label];
};
